function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2738 0.00406896C4.76335 -0.152169 0.160309 4.21051 0.00406896 9.72094C-0.152169 15.2314 4.21051 19.8404 9.72094 19.9967C15.2314 20.1469 19.8404 15.7902 19.9967 10.2738C20.0267 9.12002 19.8524 8.00832 19.5159 6.96873L18.248 8.16456C18.3982 8.83158 18.4763 9.52264 18.4583 10.2377C18.3261 14.9009 14.4261 18.5845 9.763 18.4583C5.09987 18.3261 1.41022 14.4261 1.53641 9.76301C1.66862 5.09987 5.56859 1.41022 10.2317 1.53641C11.7581 1.58449 13.1762 2.03518 14.3961 2.78633L15.5499 1.69265C14.0355 0.683109 12.2328 0.0581529 10.2738 0.00406896ZM17.6891 2.82839L8.45901 12.0585L5.92313 9.52865L5.3823 8.98181L4.29464 10.0695L4.84147 10.6103L8.45901 14.2339L18.7768 3.91606L17.6891 2.82839Z",
  fill: "black"
});

function SvgTickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick_icon.1af34c4a.svg";
export { ForwardRef as ReactComponent };